import axios from "~/plugins/axios";

export default {
  updateByAttachable(attachableId, data) {
    return axios.put(`/web_api/v1/is_attachable/${attachableId}`, data).then((response) => response.data);
  },
};
